import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=98218860&scoped=true"
import script from "./classList.vue?vue&type=script&lang=js"
export * from "./classList.vue?vue&type=script&lang=js"
import style0 from "./classList.vue?vue&type=style&index=0&id=98218860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98218860",
  null
  
)

export default component.exports